import React, { useMemo } from "react";

import ClubSearchSwiper from "../ClubSearchSwiper";
import SubscriptionCardsBlock from "../../components/SubscriptionCardsBlock/SubscriptionCardsBlock";
import SubscriptionSearchBlockMobile from "./SubscriptionSearchBlockMobile";
import { useTranslation } from "next-i18next";
import { useMediaQuery } from "../../../../../hooks/useMediaQuery";

const SubscriptionBlock = ({
  allGroupsForReturn,
  changeActiveId,
  activeTemplateGroupeId,
  allCardTemplates,
  cardOpenPriceEnabled,
}) => {
  const [t] = useTranslation();

  const activeTitle = useMemo(
    () =>
      activeTemplateGroupeId
        ? allGroupsForReturn.find(({ id }) => id == activeTemplateGroupeId)
            .title
        : "",
    [allGroupsForReturn, activeTemplateGroupeId]
  );

  const isDesktop = useMediaQuery("(min-width:501px)");

  return (
    <>
      <div className="container">
        <h2 className="club-page-title">{t("subscriptions")}</h2>

        {isDesktop && (
          <div className="subscription__desctop-search-block">
            {allGroupsForReturn?.length > 1 ? (
              <ClubSearchSwiper>
                {allGroupsForReturn.map(({ id, title }) => {
                  return (
                    <div
                      onClick={() => changeActiveId(id)}
                      className={
                        activeTemplateGroupeId === id
                          ? "club-swiper-search-element active-club-swiper-search-element"
                          : "club-swiper-search-element"
                      }
                      key={id}
                    >
                      {title}
                    </div>
                  );
                })}
              </ClubSearchSwiper>
            ) : null}
          </div>
        )}
      </div>

      {isDesktop ? (
        <SubscriptionCardsBlock
          allCards={allCardTemplates}
          // newParams={{ loop: false }}
          cardOpenPriceEnabled={cardOpenPriceEnabled}
        />
      ) : (
        <div className="subscription__mobile-search-block">
          <SubscriptionSearchBlockMobile
            activeTitle={activeTitle}
            changeActiveId={changeActiveId}
            ListOfItems={allGroupsForReturn}
            allCards={allCardTemplates}
            cardOpenPriceEnabled={cardOpenPriceEnabled}
          />
        </div>
      )}
      <style jsx global>{`
        @import "../SubscriptionCardsBlock/SubscriptionCardsBlock.scss?5";
      `}</style>
    </>
  );
};

export default SubscriptionBlock;
